import { type ThirdPartyProductsResponse } from '../../types';
import { ExperienceMark } from '../utils/experience-tracker';
import { fetchJsonWithNetworkRetries } from '../utils/fetch';
import {
	createProviderWithCustomFetchData,
	type ExportedDataProvider,
} from './create-data-provider';

export const APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS_ENDPOINT =
	'/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';

interface Params {
	cloudId?: string;
	product?: string;
}

export const appSwitcherBffThirdPartyProductsFetch = async ({
	cloudId,
	product,
}: Params): Promise<ThirdPartyProductsResponse> => {
	const params = new URLSearchParams({ source: 'app-switcher-fe' });
	if (cloudId) {
		params.append('tenantid', encodeURIComponent(cloudId));
	}
	if (product) {
		params.append('product', encodeURIComponent(product));
	}

	return await fetchJsonWithNetworkRetries<ThirdPartyProductsResponse>(
		`${APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS_ENDPOINT}?${params.toString()}`,
		{
			intervalsMS: [50, 200, 1000],
		},
		{
			headers: {
				'Atl-App-Switcher-Private-API': 'true',
			},
		},
	);
};

export const createAppSwitcherBffThirdPartyProductsProvider =
	(): ExportedDataProvider<ThirdPartyProductsResponse> => {
		return createProviderWithCustomFetchData<ThirdPartyProductsResponse, Params>(
			'appSwitcherBffThirdPartyProducts',
			ExperienceMark.API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS,
			appSwitcherBffThirdPartyProductsFetch,
		);
	};
